import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { QUERY_KEY } from '../../constants'

import { getUnreadNotificationCount } from '../../api/notice'

import { useUserInfo } from '../../hooks/useUserInfo'

import { Text } from '../../components/text'

import Logo from '../../assets/logo/logo-black.png'
import { ReactComponent as Bell } from '../../assets/ico/common/notifications/notifications_default_black.svg'
import { ReactComponent as UnreadBell } from '../../assets/ico/common/notifications/notifications_unread_black.svg'

export function Main() {
  const { data: userInfo, isLoading } = useUserInfo()

  const { data: unreadNotificationCount } = useQuery({
    queryKey: [QUERY_KEY.unreadNotificationCount],
    queryFn: getUnreadNotificationCount,
    enabled: !!userInfo,
  })

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={Logo} alt="logo-black" style={{ width: '104px' }} />
      </div>
      <NotificationContainer>
        {!isLoading && !userInfo && (
          <Text size={16} weight={700} color="text_primary">
            <Link to="/signin">로그인</Link>
          </Text>
        )}
        <NotificationLink to="/notify">{unreadNotificationCount?.result ? <UnreadBell /> : <Bell />}</NotificationLink>
      </NotificationContainer>
    </>
  )
}

const NotificationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const NotificationLink = styled(Link)`
  height: 24px;
`
